import fetch from '../../utils/fetchService';
import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
  replaceParams,
} from '../../utils/requestHelpers';

const sanitizeUrlParam = url => url.replace(/\//g, '%2F');

export const fetchApplicationSettingsFlags = async () => await fetch(
  Config.endpoints.FETCH_APPLICATION_SETTINGS_FLAGS
)
  .then(handleErrors({ errorMessage: 'Fetching application settings flags failed' }))
  .then(parseAsJson);

export const fetchAdminJobs = async () => await fetch(
  Config.endpoints.FETCH_ADMIN_JOBS
)
  .then(handleErrors({ errorMessage: 'Fetching admin jobs failed' }))
  .then(parseAsJson);

export const runAdminJob = async jobName => await fetch(
  Config.endpoints.RUN_ADMIN_JOB
    .replace(/:jobName/, sanitizeUrlParam(jobName))
)
  .then(handleErrors({ errorMessage: 'Running admin job failed' }));

export const runDeactivateUsersJob = async () => await fetch(
  Config.endpoints.RUN_DEACTIVATE_USERS_JOB,
  {
    method: 'POST',
  }
)
  .then(handleErrors({ errorMessage: 'Running deactivate users job failed' }))
  .then(parseAsJson);

export const updateApplicationSettingsFlags = async applicationSettingsFlagsData => await fetch(
  Config.endpoints.UPDATE_APPLICATION_SETTINGS_FLAGS,
  {
    method: 'PUT',
    body: JSON.stringify({ appSettingsFlags: applicationSettingsFlagsData }),
  }
)
  .then(handleErrors({ errorMessage: 'Updating application settings flags failed' }));

export const clearDevCache = async () => await fetch(
  Config.endpoints.CLEAR_DEV_CACHE,
  {
    method: 'GET',
  }
)
  .then(handleErrors({ errorMessage: 'Clearing api cache failed' }));

export const materializedViewRefresh = async () => await fetch(
  Config.endpoints.MATERIALIZED_VIEW_REFRESH,
  {
    method: 'GET',
  }
)
  .then(handleErrors({ errorMessage: 'Materialized View Refresh failed' }));

export const unlockAllTaxEntries = async () => await fetch(
  Config.endpoints.UNLOCK_ALL_TAX_ENTRIES,
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Unlocking all tax entries failed' }));

export const testRedisConnection = async () => fetch(
  Config.endpoints.TEST_REDIS_CONNECTION,
  { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }
)
  .then(handleErrors({ errorMessage: 'Redis connection test failed' }))
  .then(parseAsJson);

export const clearBsmBalances = async ( companyCode, periodName ) => await fetch(
  replaceParams(Config.endpoints.CLEAR_BSM_BALANCES, {
    companyCode,
    periodName,
  }),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Clearing BSM balances failed' }));
